import { featureFlags } from "constants/constants";
import useCheckFeatureFlag from "hooks/useCheckFeatureFlag";
import LatestTncDialog from "./TermAndConditionsDialog";
import OldTncDialog from "./Feature-flag-off-state(Remove-with-239308_KontentAITermsAndCondtions)/TermAndConditionsDialog";

type TermsAndCondtionsDialogSwitchProps = {
  isOpen: boolean;
  setIsOpen: (toogle: boolean) => void;
};

const TermsAndCondtionsDialogSwitch = (
  props: TermsAndCondtionsDialogSwitchProps,
) => {
  const { enabled, ready } = useCheckFeatureFlag(featureFlags.tnc);

  if (!ready) {
    return null;
  }

  if (enabled && ready) {
    return (
      <LatestTncDialog
        isOpen={props.isOpen}
        setIsOpen={props.setIsOpen}
      />
    );
  } else {
    return (
      <OldTncDialog
        isOpen={props.isOpen}
        setIsOpen={props.setIsOpen}
      />
    );
  }
};

export default TermsAndCondtionsDialogSwitch;